// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import type { AdvisorNotification, NotificationReferenceType } from '../types/notification';

type RouteGetter = (id: string, notification?: AdvisorNotification) => string | null;

const referenceRoutes: Record<NotificationReferenceType, RouteGetter> = {
  LOA: (id, notification) => {
    const relationshipId = notification?.metadata?.profileId as string | undefined;
    return `/relationships/${relationshipId || id}`;
  },
  RELATIONSHIP: (id) => `/relationships/${id}`,
  CLIENT: (id) => `/clients/${id}`,
  POLICY: (id) => `/policies/${id}`,
  POLICY_DOCUMENT: (id) => `/policies/${id}?tab=documents`,
  BROKERAGE: () => '/settings',
  // Advisor-addressed events (assessment completed, executive summary ready)
  // carry the relationship in metadata.profileId — navigate there. Advisor
  // lifecycle events (role promoted, deactivated) have no profile and stay
  // non-navigable.
  ADVISOR: (_id, notification) => {
    const relationshipId = notification?.metadata?.profileId as string | undefined;
    return relationshipId ? `/relationships/${relationshipId}` : null;
  },
  PROFILE: (id) => `/relationships/${id}`,
};

/**
 * Returns the navigation route for a notification, or null if not navigable.
 */
export function getNotificationRoute(notification: AdvisorNotification): string | null {
  if (!notification.referenceType || !notification.referenceId) return null;
  const getRoute = referenceRoutes[notification.referenceType];
  if (!getRoute) return null;
  return getRoute(notification.referenceId, notification);
}
